import { Data } from '@measured/puck';
import * as Sentry from '@sentry/react';

// export const ConvertJsonToBase64 = (data: object): string => {
//   try {
//     const jsonString = JSON.stringify(data);
//     const utf8Bytes = new TextEncoder().encode(jsonString);
//     const base64String = btoa(String.fromCharCode(...utf8Bytes));
//     return base64String;
//   } catch (error) {
//     console.error('Error while converting JSON to Base64', error);
//     return '';
//   }
// };

export const ConvertJsonToBase64 = (data: object): string => {
  try {
    // Convert the object to a JSON string
    const jsonString = JSON.stringify(data);

    // Encode the string into a UTF-8 byte array
    const utf8Bytes = new TextEncoder().encode(jsonString);

    // Convert the byte array into a Base64-encoded string
    let base64String = '';
    for (let i = 0; i < utf8Bytes.length; i += 3) {
      base64String += String.fromCharCode(utf8Bytes[i]);
      if (i + 1 < utf8Bytes.length) {
        base64String += String.fromCharCode(utf8Bytes[i + 1]);
      }
      if (i + 2 < utf8Bytes.length) {
        base64String += String.fromCharCode(utf8Bytes[i + 2]);
      }
    }

    // Return the Base64 encoded string
    return btoa(base64String);
  } catch (error) {
    console.error('Error while converting JSON to Base64', error);
    return '';
  }
};

// converting base64 to bytearray and then to json
export const ConvertBase64ToJson = (base64String: string): Data => {
  try {
    const base64DecodedArray = new Uint8Array(
      atob(base64String)
        .split('')
        .map(char => char.charCodeAt(0)),
    );
    const decodedJsonString = new TextDecoder()
      .decode(base64DecodedArray)
      .replaceAll('{', '[')
      .replaceAll('}', ']');

    const base64DecodedBinary = atob(decodedJsonString);
    const utf8ByteArray = new Uint8Array(
      base64DecodedBinary.split('').map(char => char.charCodeAt(0)),
    );
    const finalJsonString = new TextDecoder().decode(utf8ByteArray);
    const jsonObject = JSON.parse(finalJsonString);
    return jsonObject;
  } catch (error) {
    console.error('Error while converting Base64 to JSON', error);
    const errorDetails = {
      date: new Date().toISOString(),
      errorIn: 'Error while converting Base64 to JSON',
      base64String: base64String,
      error: error,
    };
    Sentry.captureException(new Error(JSON.stringify(errorDetails)));
    return {
      content: [],
      root: {},
      zones: {},
    };
  }
};
